<template>
   <v-app>
      <div class="login-shell">
         <!-- ============ Branding panel ============ -->
         <aside class="brand-side d-none d-lg-flex">
            <div class="brand-decor decor-1"></div>
            <div class="brand-decor decor-2"></div>
            <div class="brand-decor decor-3"></div>

            <div class="brand-inner">
               <div class="brand-top">
                  <div class="logo-badge">
                     <img src="../assets/mow.png" alt="Ministry logo" />
                  </div>
                  <div class="brand-names">
                     <span class="brand-name">MOWFAHR Portal</span>
                     <span class="brand-tag">Jubaland State of Somalia</span>
                  </div>
               </div>

               <div class="brand-hero">
                  <h1 class="hero-title">
                     Ministry of Women,<br />
                     Family Affairs &amp;<br />
                     Human Rights
                  </h1>
                  <p class="hero-text">
                     A secure management portal for child protection,
                     care-giver registration and district-level reporting.
                  </p>

                  <ul class="hero-points">
                     <li>
                        <v-icon small color="#90caf9">mdi-shield-check-outline</v-icon>
                        <span>Role &amp; district-based access control</span>
                     </li>
                     <li>
                        <v-icon small color="#90caf9">mdi-chart-box-outline</v-icon>
                        <span>Real-time dashboards &amp; reports</span>
                     </li>
                     <li>
                        <v-icon small color="#90caf9">mdi-account-group-outline</v-icon>
                        <span>Child &amp; care-giver case management</span>
                     </li>
                  </ul>
               </div>

               <div class="brand-bottom">
                  <span>&copy; {{ year }} Ministry of Women, Family Affairs &amp; Human Rights</span>
                  <span class="dot-sep">&middot;</span>
                  <span>v2.0</span>
               </div>
            </div>
         </aside>

         <!-- ============ Form panel ============ -->
         <main class="form-side">
            <div class="form-box">
               <div class="mobile-brand d-flex d-lg-none">
                  <img src="../assets/mow.png" alt="Ministry logo" />
                  <div>
                     <strong>MOWFAHR Portal</strong>
                     <small>Ministry of Women, Family Affairs &amp; Human Rights</small>
                  </div>
               </div>

               <h2 class="form-title">Welcome back</h2>
               <p class="form-sub">Sign in to your account to continue</p>

               <v-alert
                  v-if="alert"
                  type="error"
                  dense
                  outlined
                  dismissible
                  class="login-alert"
                  @input="alert = false"
               >
                  {{ message }}
               </v-alert>

               <v-form @submit.prevent="login" class="login-form">
                  <label class="field-label" for="username">Username</label>
                  <v-text-field
                     id="username"
                     v-model="datalogin.username"
                     placeholder="Enter your username"
                     prepend-inner-icon="mdi-account-outline"
                     outlined
                     dense
                     autocomplete="username"
                     :disabled="loading"
                     class="login-field"
                  ></v-text-field>

                  <label class="field-label" for="password">Password</label>
                  <v-text-field
                     id="password"
                     v-model="datalogin.password"
                     placeholder="Enter your password"
                     prepend-inner-icon="mdi-lock-outline"
                     :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                     :type="showPassword ? 'text' : 'password'"
                     @click:append="showPassword = !showPassword"
                     @keyup="checkCaps"
                     outlined
                     dense
                     autocomplete="current-password"
                     :disabled="loading"
                     class="login-field"
                  ></v-text-field>

                  <transition name="fade">
                     <div v-if="capsLock" class="caps-hint">
                        <v-icon x-small color="#ed6c02">mdi-alert-outline</v-icon>
                        Caps Lock is on
                     </div>
                  </transition>

                  <v-btn
                     type="submit"
                     block
                     x-large
                     :loading="loading"
                     :disabled="loading"
                     class="login-btn"
                     elevation="0"
                  >
                     <span v-if="!loading">Sign In</span>
                     <v-icon v-if="!loading" right small>mdi-arrow-right</v-icon>
                  </v-btn>
               </v-form>

               <div class="secure-note">
                  <v-icon x-small color="#9e9e9e">mdi-lock-outline</v-icon>
                  <span>Authorized personnel only &middot; All activity is monitored</span>
               </div>
            </div>

            <div class="form-footer d-lg-none">
               &copy; {{ year }} MOWFAHR Portal
            </div>
         </main>
      </div>

      <!-- ===== Signing-in overlay ===== -->
      <v-overlay :value="signingIn" :z-index="9999" :opacity="1" color="#0d2d63">
         <div class="signin-box">
            <img src="../assets/mow.png" alt="Ministry Logo" class="signin-logo" />
            <v-progress-circular indeterminate size="34" width="3" color="#90caf9" class="my-4"></v-progress-circular>
            <div class="signin-text">Welcome back{{ welcomeName ? ', ' + welcomeName : '' }}</div>
            <div class="signin-sub">Preparing your dashboard&hellip;</div>
         </div>
      </v-overlay>
   </v-app>
</template>

<script>
import axios from 'axios';
var url = process.env.VUE_APP_API_URL;
export default {
   data(){
      return{
           op:0,
           showPassword: false,
           loading: false,
           signingIn: false,
           welcomeName: '',
           capsLock: false,
           year: new Date().getFullYear(),
           datalogins:[],
           datalogin:{
            username:'',
            password:''
         }, 
         msg:'', 
         alert: false,
         message:''
      }
   },
   methods:{
      checkCaps:function(e) {
         if (e.getModifierState) this.capsLock = e.getModifierState('CapsLock');
      },
      login:function() {
      this.op=20;
      axios.post(url,{opcion:23,username:this.datalogin.username,password:this.datalogin.password,op:this.op})
      .then(response =>{
       this.datalogins = response.data; 
       console.log(response.data)
       console.log(this.datalogins);
       this.alert=true
        if(response.data[0].msg == 'not'){
          this.message='Your user is not active';
          setTimeout(()=>{
            this.alert=false
         },2000)
       }
       else if(response.data[0].msg == 'fill'){
         this.message='Fill in the Blank Space';
         setTimeout(()=>{
            this.alert=false
         },2000)
       }else if(response.data[0].msg == 'wrong'){
         this.message='UserName or Password Is Incorrect';
         setTimeout(()=>{
            this.alert=false
         },2000)
       } else {
      localStorage.setItem('username',response.data[0].Username);
      localStorage.setItem('fname',response.data[0].FullName)
      localStorage.setItem('usertype',response.data[0].Role);
      // Store auth status as JSON boolean
      localStorage.setItem('status', JSON.stringify(true));
      // Store normalized user object for router guard
      const role = (response.data[0].Role || '').toString().trim().toLowerCase();
      const userPayload = {
        id: response.data[0].UserID || response.data[0].id || null,
        name: response.data[0].FullName,
        role,
        pic: response.data[0].PicLoc || null,
        district: response.data[0].district || null,
        districts: response.data[0].districts || [],
      };
      // Non-admin accounts must have at least one assigned district
      const hasDistrict = !!(userPayload.district && String(userPayload.district).trim())
        || (Array.isArray(userPayload.districts) && userPayload.districts.length > 0);
      if (role !== 'admin' && !hasDistrict) {
        this.alert = true;
        this.message = 'Your account has no district assigned. Please contact the administrator.';
        setTimeout(() => { this.alert = false }, 3500);
        return;
      }
      localStorage.setItem('user', JSON.stringify(userPayload));
      this.$emit("authenticated",true);
      // Show the welcome overlay, then redirect to the requested page or home
      this.alert = false;
      this.signingIn = true;
      this.welcomeName = (response.data[0].FullName || '').split(' ')[0];
      const redirect = this.$route.query.redirect ? { path: this.$route.query.redirect } : { name: 'home' };
      setTimeout(() => {
         this.$router.replace(redirect);
      }, 900);
       }
             
      }).catch(error=>{
         this.loading = false;
         this.alert = true;
         this.message = 'Could not reach the server. Please try again.';
         console.log(error);
      });
   },
   mounted(){
      this.$emit("authenticated",false);
      // Show why the session was ended (force logout from heartbeat)
      const reason = this.$route.query.reason;
      if (reason === 'deactivated') {
         this.alert = true;
         this.message = 'Your account has been deactivated. Please contact the administrator.';
      } else if (reason === 'district') {
         this.alert = true;
         this.message = 'Your district access was removed. Please contact the administrator.';
      }
   }
}
}
</script>

<style scoped>
/* ===== Layout ===== */
.login-shell {
   display: flex;
   min-height: 100vh;
   background: #f4f6fb;
}

/* ===== Brand side ===== */
.brand-side {
   position: relative;
   flex: 0 0 46%;
   flex-direction: column;
   overflow: hidden;
   color: #fff;
   background: linear-gradient(155deg, #123a7d 0%, #0d2d63 45%, #071c44 100%);
}
.brand-decor {
   position: absolute;
   border-radius: 50%;
   pointer-events: none;
}
.decor-1 {
   width: 480px; height: 480px;
   top: -160px; right: -140px;
   background: radial-gradient(circle, rgba(66, 165, 245, .28) 0%, transparent 65%);
}
.decor-2 {
   width: 360px; height: 360px;
   bottom: -120px; left: -100px;
   background: radial-gradient(circle, rgba(144, 202, 249, .16) 0%, transparent 65%);
}
.decor-3 {
   width: 220px; height: 220px;
   top: 42%; right: -80px;
   border: 1px solid rgba(255, 255, 255, .08);
}
.brand-inner {
   position: relative;
   z-index: 1;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   height: 100%;
   padding: 48px 56px;
}
.brand-top {
   display: flex;
   align-items: center;
   gap: 14px;
}
.logo-badge {
   width: 58px; height: 58px;
   display: flex;
   align-items: center;
   justify-content: center;
   background: rgba(255, 255, 255, .12);
   border: 1px solid rgba(255, 255, 255, .18);
   border-radius: 14px;
   backdrop-filter: blur(6px);
}
.logo-badge img {
   width: 44px; height: 44px;
   object-fit: contain;
}
.brand-names {
   display: flex;
   flex-direction: column;
}
.brand-name {
   font-size: 1.05rem;
   font-weight: 700;
   letter-spacing: .3px;
}
.brand-tag {
   font-size: .75rem;
   opacity: .65;
   letter-spacing: .6px;
   text-transform: uppercase;
}
.hero-title {
   font-size: 2.4rem;
   font-weight: 800;
   line-height: 1.25;
   letter-spacing: -.5px;
   margin-bottom: 18px;
}
.hero-text {
   font-size: .95rem;
   line-height: 1.7;
   opacity: .78;
   max-width: 400px;
   margin-bottom: 34px;
}
.hero-points {
   list-style: none;
   padding: 0;
   margin: 0;
}
.hero-points li {
   display: flex;
   align-items: center;
   gap: 12px;
   padding: 10px 0;
   font-size: .88rem;
   opacity: .9;
}
.brand-bottom {
   font-size: .75rem;
   opacity: .55;
   letter-spacing: .3px;
}
.dot-sep { margin: 0 8px; }

/* ===== Form side ===== */
.form-side {
   flex: 1;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 40px 24px;
}
.form-box {
   width: 100%;
   max-width: 400px;
   animation: rise .5s ease both;
}
@keyframes rise {
   from { opacity: 0; transform: translateY(14px); }
   to   { opacity: 1; transform: translateY(0); }
}
.mobile-brand {
   align-items: center;
   gap: 14px;
   margin-bottom: 36px;
}
.mobile-brand img {
   width: 52px; height: 52px;
   object-fit: contain;
}
.mobile-brand div {
   display: flex;
   flex-direction: column;
}
.mobile-brand strong {
   font-size: .95rem;
   color: #123a7d;
}
.mobile-brand small {
   font-size: .72rem;
   color: #8a94a6;
}
.form-title {
   font-size: 1.75rem;
   font-weight: 800;
   color: #16233f;
   letter-spacing: -.4px;
}
.form-sub {
   color: #7a8699;
   font-size: .92rem;
   margin-bottom: 30px;
}
.login-alert {
   border-radius: 10px;
   font-size: .85rem;
}
.field-label {
   display: block;
   font-size: .8rem;
   font-weight: 600;
   color: #45526b;
   margin-bottom: 6px;
   letter-spacing: .2px;
}
.login-field {
   border-radius: 10px;
}
.login-field >>> .v-input__control .v-input__slot {
   min-height: 48px !important;
}
.login-field >>> fieldset {
   border-color: #dde3ee;
}
.login-field >>> .v-input__slot:hover fieldset {
   border-color: #b8c4da;
}
.caps-hint {
   display: flex;
   align-items: center;
   gap: 6px;
   font-size: .78rem;
   color: #ed6c02;
   margin: -8px 0 12px 2px;
}
.login-btn {
   height: 50px !important;
   border-radius: 12px !important;
   font-size: .95rem;
   font-weight: 700;
   letter-spacing: .4px;
   text-transform: none;
   color: #fff !important;
   background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%) !important;
   margin-top: 10px;
   transition: box-shadow .2s ease, transform .15s ease;
}
.login-btn:hover:not(.v-btn--disabled) {
   box-shadow: 0 8px 22px rgba(13, 71, 161, .35) !important;
   transform: translateY(-1px);
}
.secure-note {
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 6px;
   margin-top: 34px;
   font-size: .74rem;
   color: #9aa5b5;
}
.form-footer {
   margin-top: 40px;
   font-size: .72rem;
   color: #9aa5b5;
}
.fade-enter-active, .fade-leave-active { transition: opacity .2s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ===== Sign-in overlay ===== */
.signin-box {
   display: flex;
   flex-direction: column;
   align-items: center;
   text-align: center;
}
.signin-logo {
   width: 72px;
   height: 72px;
   object-fit: contain;
   background: rgba(255, 255, 255, .1);
   border-radius: 18px;
   padding: 8px;
}
.signin-text {
   color: #fff;
   font-size: 1.05rem;
   font-weight: 700;
   letter-spacing: .3px;
}
.signin-sub {
   color: #7e9cc9;
   font-size: .78rem;
   margin-top: 4px;
}

@media (max-width: 1263px) {
   .brand-side { flex-basis: 42%; }
   .brand-inner { padding: 40px 40px; }
   .hero-title { font-size: 2rem; }
}
</style>
